export default () => ({
    count: 0,
    tasks: [],
    push(task) {
        this.tasks.push(task);
    }
});
